import React, { useEffect, useRef, useState } from "react";
import { CircularProgress } from "@mui/material";
import { ChevronDownIcon } from "./icons";

/**
 * Download button with options: { key, label, detail, help, disabled, onSelect }.
 */
export default function DownloadMenu({ options, busy, disabled }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e) => !rootRef.current?.contains(e.target) && setOpen(false);
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("pointerdown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("pointerdown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <div className="sw-download" ref={rootRef}>
      <button type="button" className="sw-button sw-primary sw-download-toggle" aria-haspopup="menu" aria-expanded={open} disabled={disabled || busy} onClick={() => setOpen((v) => !v)}>
        {busy ? <CircularProgress size={14} sx={{ color: "#fff" }} /> : null}
        <span>{busy ? "Preparing…" : "Download"}</span>
        <ChevronDownIcon />
      </button>
      {open && (
        <div className="sw-download-options" role="menu">
          {options.map((o) => (
            <button
              key={o.key}
              type="button"
              role="menuitem"
              disabled={o.disabled}
              title={o.help}
              onClick={() => {
                setOpen(false);
                o.onSelect();
              }}
            >
              <span>{o.label}</span>
              {o.detail && <small>{o.detail}</small>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
